import { LevelOfDetailDTO } from './LevelOfDetailDTO'

export class CatchmentDTO {
  constructor(readonly levelsOfDetail: Array<LevelOfDetailDTO>) {}
}
